/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareNotesFactory {
        getInstance(locationId: number, type: string, modelId: number) : IDealerwareNotesCollection;
        getVehicleInstance(locationId: number, modelId: number) : IDealerwareVehicleNotesCollection;
        getContractInstance(locationId: number, modelId: number) : IDealerwareContractNotesCollection;
        getCustomerInstance(locationId: number, modelId: number) : IDealerwareCustomerNotesCollection;
    }

    export interface IDealerwareHasNotes {
        noteCollection : IDealerwareNotesCollection;
        loadNotes() : ng.IPromise<{}>;
    }

    export interface IDealerwareNotesCollection {
        notes: any;
        type: string;
        displayType: string;
        locationId: number;
        modelId: number;

        isNotesLoaded() : boolean;
        loadNotes() : ng.IPromise<{}>;
    }

    export interface IDealerwareVehicleNotesCollection extends IDealerwareNotesCollection {}
    export interface IDealerwareCustomerNotesCollection extends IDealerwareNotesCollection {}
    export interface IDealerwareContractNotesCollection extends IDealerwareNotesCollection {}

    export class NotesCollection implements IDealerwareNotesCollection {
        public static $inject : string[] = ['$q','DealerwareNoteCollection'];

        public notes: any;
        public type: string;
        public displayType: string;
        public locationId: number;
        public modelId: number;

        constructor(public $q: any,public DealerwareNoteCollection: any) {}

        public isNotesLoaded() : boolean {
            return (this.notes) ? true : false;
        }

        public loadNotes() : ng.IPromise<{}> {
            var _self = this;
            var _deferred = this.$q.defer();

            this.DealerwareNoteCollection.index({
                promise: true,
                params: {
                    location_id: this.locationId,
                    type: this.type,
                    model_id: this.modelId
                }
            }).then(
                function(returnValue: any, response: any) {
                    _self.notes = returnValue;
                    _deferred.resolve(returnValue,response);
                },
                function(response: any) {
                    _deferred.reject(response);
                }
            );

            return _deferred.promise;
        }
    }

    export class VehicleNotesCollection extends NotesCollection implements IDealerwareVehicleNotesCollection {
        constructor(public $q: any, public DealerwareNoteCollection: any) {
            super($q,DealerwareNoteCollection);
            this.type = 'cars' ;
            this.displayType = 'Vehicle';
        }
    }

    export class CustomerNotesCollection extends NotesCollection implements IDealerwareCustomerNotesCollection {
        constructor(public $q: any, public DealerwareNoteCollection: any) {
            super($q,DealerwareNoteCollection);
            this.type = 'customers';
            this.displayType = 'Customer';
        }
    }

    export class ContractNotesCollection extends NotesCollection implements IDealerwareContractNotesCollection {
        constructor(public $q: any, public DealerwareNoteCollection: any) {
            super($q,DealerwareNoteCollection);
            this.type = 'reservations';
            this.displayType = 'Contract';
        }
    }

    export class NotesFactory implements IDealerwareNotesFactory {
        public static $inject : string[] = ['$q','DealerwareNoteCollection'];

        constructor(public $q: any, public DealerwareNoteCollection: any) {}

        public getInstance(locationId: number, type: string, modelId: number ) : IDealerwareNotesCollection {
            var _nc = new NotesCollection(this.$q, this.DealerwareNoteCollection);
            _nc.locationId = locationId;
            _nc.modelId = modelId;
            _nc.type = type;
            return _nc;
        }

        public getVehicleInstance(locationId: number, modelId: number) : IDealerwareVehicleNotesCollection {
            var _nc = new VehicleNotesCollection(this.$q, this.DealerwareNoteCollection);
            _nc.locationId = locationId;
            _nc.modelId = modelId;
            return _nc;
        }

        public getContractInstance(locationId: number, modelId: number) : IDealerwareContractNotesCollection {
            var _nc = new ContractNotesCollection(this.$q, this.DealerwareNoteCollection);
            _nc.locationId = locationId;
            _nc.modelId = modelId;
            return _nc;
        }

        public getCustomerInstance(locationId: number, modelId: number) : IDealerwareCustomerNotesCollection {
            var _nc = new CustomerNotesCollection(this.$q, this.DealerwareNoteCollection);
            _nc.locationId = locationId;
            _nc.modelId = modelId;
            return _nc;
        }
    }

    getDealerwareWebServicesModule().service("$DealerwareNotesFactory", NotesFactory);
}